export default __webpack_public_path__ + "static/media/headshot-min.48ce3831.jpg";